(() => {
  'use strict';
  /* =========================================
     E-SCOOTER-FINDER CONFIG — Edit this section only.
     Maintain SKU priorities and temporary business exclusions only.
     Product facts are resolved dynamically through Shopify APIs.
     Do NOT add handles, titles, prices or availability here.
  ========================================= */
  // Business strategy only. Shopify resolves every SKU to its current product/handle.
  const ESF_BUSINESS_RULES = {
  "temporaryExclusions": [],
  "scenarioPriority": {
    "short_city_trips": [
      "01gt3",
      "01g5pro",
      "01gt3pro",
      "01g5max",
      "01gt3max",
      "01st3",
      "01gt5pro",
      "01gt5max"
    ],
    "daily_commuting": [
      "01gt3max",
      "01st3pro",
      "01st3",
      "01gt3pro",
      "01gt3",
      "01g5max",
      "01g5pro",
      "01gt5pro",
      "01gt5max",
      "01st5pro",
      "01st5max"
    ],
    "rough_roads": [
      "01n65i2",
      "01nt5max",
      "01xt5pro",
      "01ut5max",
      "01nt5ultrax",
      "01xt5ultra"
    ],
    "longer_range": [
      "01gt5max",
      "01st5max",
      "01gt5pro",
      "01st3pro",
      "01st5pro",
      "01gt3max",
      "01g5max",
      "01n65i2",
      "01nt5max",
      "01ut5max",
      "01nt5ultrax",
      "01xt5ultra",
      "01xt5pro"
    ]
  }
};
  const ESF_DEBUG = false; // Enable diagnostic logs; never changes eligibility/ranking.
  const ESF_FALLBACK = {
    maxDistance: 15000, // EUR cents outside the band; not a configured product price.
    limit: 2,
    scenarioRelevance: {
      short_city_trips: "Une sélection pour vos courts trajets en ville",
      daily_commuting: "Une sélection pour vos trajets quotidiens en ville",
      rough_roads: "Une sélection pour plus de confort sur les routes irrégulières",
      longer_range: "Une sélection pour vos trajets plus longs"
    }
  };
  // Inclusive min, EXCLUSIVE max: 300/500/700 never belong to two bands.
  // FR budgets require EUR and the France storefront context.
  const ESF_BUDGETS = {
    under_300: { min: 0, max: 30000 },
    '300_500': { min: 30000, max: 50000 },
    '500_700': { min: 50000, max: 70000 },
    over_700: { min: 70000, max: Infinity }
  };
  const ESF_SCENARIO_COPY = {
    short_city_trips: {
      label: "Courts trajets en ville", resultSubtitle: "Notre recommandation pour vos courts trajets en ville",
      reason: "Vous souhaitez surtout effectuer de courts trajets en ville. Nous vous proposons donc des modèles pratiques pour le quotidien, dans la tranche de budget choisie.",
      benefits: ["Dans la tranche de budget choisie", "Pour vos courts déplacements du quotidien", "Une sélection pour vos déplacements en ville"]
    },
    daily_commuting: {
      label: "Trajets quotidiens", resultSubtitle: "Notre recommandation pour vos trajets quotidiens",
      reason: "Vous souhaitez utiliser votre trottinette pour vos trajets quotidiens. Nous privilégions donc des modèles adaptés aux déplacements en ville, dans la tranche de budget choisie.",
      benefits: ["Dans la tranche de budget choisie", "Une sélection pour vos trajets réguliers en ville", "Une sélection parmi nos modèles pour le quotidien"]
    },
    rough_roads: {
      label: "Confort sur routes irrégulières", resultSubtitle: "Notre recommandation pour plus de confort sur les routes irrégulières",
      reason: "Vous recherchez davantage de confort sur les routes irrégulières. Nous avons sélectionné des modèles correspondant à cet usage et à votre budget. Consultez la fiche produit pour connaître leur équipement exact.",
      benefits: ["Dans la tranche de budget choisie", "Une sélection pour plus de confort", "Une sélection parmi nos modèles pour les routes irrégulières"]
    },
    longer_range: {
      label: "Plus longue autonomie", resultSubtitle: "Notre recommandation pour vos trajets plus longs",
      reason: "Vous souhaitez parcourir de plus longues distances. Nous avons sélectionné des modèles correspondant à cet usage et à votre budget. Consultez la fiche produit pour connaître leur autonomie et les conditions de test.",
      benefits: ["Dans la tranche de budget choisie", "Une sélection pour vos trajets plus longs", "Une sélection parmi nos modèles pour les trajets plus longs"]
    }
  };
  // Shopify CDN fallback photos. Theme Editor image pickers take precedence.
  const ESF_SCENARIO_IMAGES = {
    short_city_trips: 'https://cdn.shopify.com/s/files/1/0894/4468/0027/articles/navee-e-scooter-guenstig-stadtfahrt_a8a3ae73-9bf9-4dd8-ae27-db80796c3c26.webp?width=700',
    daily_commuting: 'https://cdn.shopify.com/s/files/1/0894/4468/0027/articles/e-scooter-fuer-erwachsen_83c1e59a-e794-435f-9049-e50cd1499b77.jpg?width=700',
    rough_roads: 'https://cdn.shopify.com/s/files/1/0894/4468/0027/articles/e-scooter-mit-federung_af6759f1-fa1c-4e7d-924b-bd32bf390808.jpg?width=700',
    longer_range: 'https://cdn.shopify.com/s/files/1/0894/4468/0027/articles/e-scooter-kaufen-kaufberatung_b4c37f8b-c78d-47dc-b170-fed5a9ed6b5b.webp?width=700'
  };
  /* =============== END CONFIG =============== */

  // Guard against duplicate asset tags and support Theme Editor section reloads.
  if (window.__esfInitialized) return;
  window.__esfInitialized = true;
  const ESF_PRODUCT_CACHE = new Map();
  const ESF_INDEX_CACHE = new Map();
  const routeRoot = () => window.Shopify?.routes?.root || '/';
  const currency = () => window.Shopify?.currency?.active || 'EUR';
  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "fr-FR", {
        style: 'currency', currency: currency()
      }).format(cents / 100);
    } catch (_) { return `${(cents / 100).toFixed(2)} ${currency()}`; }
  }
  function budgetLabel(key) {
    const b = ESF_BUDGETS[key];
    if (key === 'under_300') return `Moins de ${formatMoney(b.max)}`;
    if (key === 'over_700') return `À partir de ${formatMoney(b.min)}`;
    return `${formatMoney(b.min)}–${formatMoney(b.max)}`;
  }
  function isWithinBudget(price, key) {
    const b = ESF_BUDGETS[key];
    return Number.isSafeInteger(price) && !!b && price >= b.min && price < b.max;
  }
  function closestOptions(availableProducts, budget) {
    const range = ESF_BUDGETS[budget];
    if (!range) return [];
    return availableProducts.flatMap((product, priority) => {
      if (isWithinBudget(product.price, budget)) return [];
      const above = product.price >= range.max;
      const distance = above ? product.price - range.max : range.min - product.price;
      if (!Number.isSafeInteger(distance) || distance < 0 || distance > ESF_FALLBACK.maxDistance) return [];
      return [{ ...product, budgetRelation: above ? 'above' : 'below', budgetDistance: distance, priority }];
    }).sort((a, b) => {
      // Above-budget first, then closest price; ties retain the scenario's business order.
      const direction = Number(a.budgetRelation === 'below') - Number(b.budgetRelation === 'below');
      return direction || a.budgetDistance - b.budgetDistance || a.priority - b.priority;
    }).slice(0, ESF_FALLBACK.limit);
  }
  function trackFinderEvent(event, params = {}) {
    try { if (typeof window.dataLayer?.push === 'function') window.dataLayer.push({ event, ...params }); }
    catch (_) { /* Analytics must never block UI. */ }
  }
  function safeImage(src) {
    if (typeof src !== 'string' || !src) return '';
    try { const u = new URL(src, location.origin); return u.protocol === 'https:' ? u.href : ''; }
    catch (_) { return ''; }
  }
  function debugFinder(details) {
    if (!ESF_DEBUG) return;
    try { console.info('[E-Scooter-Finder]', details); } catch (_) {}
  }
  async function shopifyRequest(url, asText = false) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal, cache: 'no-store' });
      if (!response.ok) throw new Error(`Shopify request failed (${response.status})`);
      return asText ? await response.text() : await response.json();
    } finally { clearTimeout(timeout); }
  }
  function isAdultScooter(product) {
    if (!product?.storefrontPublished || !['E-Scooters', 'Trottinette Ville'].includes(product.type) || product.excluded || product.discontinued) return false;
    // Actual FR catalog metadata, inspected via Admin API. Names never determine the pool.
    const deniedCollections = new Set(['produit-arrete', 'trottinette-electrique-enfant', 'refurbished-product', 'pack-essentiel', 'accessories', 'velo-electrique', 'chariot-de-golf-electrique', 'exosquelette']);
    if (!Array.isArray(product.collections) || product.collections.some(c => deniedCollections.has(c))) return false;
    const adultCollections = new Set(['trottinette-electrique', 'trottinette-electrique-ville', 'trottinette-electrique-performante', 'daily-commuter', 'offroad-adventure', 'tout-terrain-polyvalent']);
    if (!product.collections.some(c => adultCollections.has(c))) return false;
    const deniedTags = new Set(['discontinued', 'refurbished', 'bundle', 'accessory', 'spare-part', 'kids', 'finder:exclude']);
    return Array.isArray(product.tags) && !product.tags.some(t => deniedTags.has(String(t).toLowerCase()));
  }
  async function getProductIndex() {
    const cacheKey = `${routeRoot()}|${currency()}|${window.Shopify?.country || ''}`;
    if (ESF_INDEX_CACHE.has(cacheKey)) return ESF_INDEX_CACHE.get(cacheKey);
    const promise = (async () => {
      const productIndexBySku = new Map(), ambiguousSkus = new Set();
      let page = 1, pages = 1;
      do {
        const url = new URL(routeRoot(), location.origin);
        url.searchParams.set('section_id', 'e-scooter-finder-catalog');
        url.searchParams.set('page', String(page));
        // Preview fetches must use the same test theme, without changing browser history.
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
        const html = await shopifyRequest(url.href, true);
        const dataNode = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-esf-catalog]');
        if (!dataNode) throw new Error('Shopify catalog section unavailable.');
        const catalog = JSON.parse(dataNode.textContent);
        if (catalog.version !== 1 || !Array.isArray(catalog.products) || catalog.country !== 'FR' || catalog.currency !== 'EUR' || catalog.currency !== currency()) throw new Error('Shopify France catalog context mismatch.');
        if (!Number.isInteger(catalog.pages) || catalog.pages < 0 || catalog.pages > 100 || catalog.page !== page) throw new Error('Invalid catalog pagination.');
        pages = catalog.pages;
        catalog.products.forEach(product => {
          if (!isAdultScooter(product) || !product.handle || !Array.isArray(product.variants)) return;
          product.variants.forEach(variant => {
            const sku = variant.sku;
            if (typeof sku !== 'string' || !sku || !variant.id || ambiguousSkus.has(sku)) return;
            // Duplicate SKUs cannot silently resolve to a test product or wrong variant.
            if (productIndexBySku.has(sku)) { productIndexBySku.delete(sku); ambiguousSkus.add(sku); }
            else productIndexBySku.set(sku, { product, variant });
          });
        });
        page++;
      } while (page <= pages);
      debugFinder({ indexedSkus: [...productIndexBySku.keys()], ambiguousSkus: [...ambiguousSkus] });
      return productIndexBySku;
    })();
    ESF_INDEX_CACHE.set(cacheKey, promise);
    try { return await promise; }
    catch (error) { ESF_INDEX_CACHE.delete(cacheKey); throw error; }
  }
  async function fetchProduct(sku, item) {
    const handle = item.product.handle;
    const cacheKey = `${routeRoot()}|${currency()}|${handle}`;
    if (!ESF_PRODUCT_CACHE.has(cacheKey)) {
      const promise = shopifyRequest(`${routeRoot()}products/${encodeURIComponent(handle)}.js`);
      ESF_PRODUCT_CACHE.set(cacheKey, promise);
      promise.catch(() => ESF_PRODUCT_CACHE.delete(cacheKey));
    }
    const product = await ESF_PRODUCT_CACHE.get(cacheKey);
    const variants = Array.isArray(product.variants) ? product.variants.filter(v => v.sku === sku) : [];
    if (variants.length !== 1 || String(variants[0].id) !== String(item.variant.id) || String(product.id) !== String(item.product.id)) throw new Error(`SKU/variant mapping changed or missing: ${sku}`);
    const v = variants[0];
    if (!Number.isSafeInteger(v.price) || v.price < 0 || typeof v.available !== 'boolean' || !product.handle || typeof product.title !== 'string') throw new Error(`Invalid Shopify variant data: ${sku}`);
    return {
      key: sku, productId: product.id, variantId: v.id, sku: v.sku,
      title: product.title, handle: product.handle, price: v.price,
      compareAtPrice: Number.isSafeInteger(v.compare_at_price) ? v.compare_at_price : null,
      available: v.available,
      image: safeImage(v.featured_image?.src || product.featured_image || product.images?.[0] || ''),
      url: `${routeRoot()}products/${encodeURIComponent(product.handle)}?variant=${encodeURIComponent(v.id)}`
    };
  }
  async function getRecommendations(scenario, budget) {
    const rankedSkus = [...new Set(ESF_BUSINESS_RULES.scenarioPriority[scenario] || [])];
    const excluded = new Set(ESF_BUSINESS_RULES.temporaryExclusions);
    const productIndexBySku = await getProductIndex();
    const diagnostics = [], candidates = [];
    rankedSkus.forEach(sku => {
      if (excluded.has(sku)) diagnostics.push({ sku, status: 'business exclusion' });
      else if (!productIndexBySku.has(sku)) diagnostics.push({ sku, status: 'missing SKU or invalid/unpublished adult product' });
      else candidates.push(sku);
    });
    const settled = await Promise.allSettled(candidates.map(sku => fetchProduct(sku, productIndexBySku.get(sku))));
    const products = [], availableProducts = []; let loaded = 0;
    settled.forEach((r, i) => {
      const sku = candidates[i];
      if (r.status === 'rejected') { console.warn('[E-Scooter-Finder]', sku, r.reason?.message); diagnostics.push({ sku, status: 'API/mapping error' }); return; }
      const p = r.value; loaded++;
      if (!p.available) diagnostics.push({ sku, title: p.title, status: 'unavailable' });
      else {
        availableProducts.push(p);
        if (!isWithinBudget(p.price, budget)) diagnostics.push({ sku, title: p.title, status: 'outside budget' });
        else { products.push(p); diagnostics.push({ sku, title: p.title, status: 'eligible' }); }
      }
    });
    debugFinder({ scenario, budget, rankedSkus, matchedShopifyProducts: diagnostics, finalRecommendations: products.slice(0, 3).map(p => p.sku) });
    if (candidates.length && !loaded) throw new Error('All candidate products failed to load.');
    const fallbacks = products.length ? [] : closestOptions(availableProducts, budget);
    debugFinder({ fallbackRecommendations: fallbacks.map(p => ({ sku: p.sku, relation: p.budgetRelation, distance: p.budgetDistance })) });
    return { best: products[0] || null, alternative1: products[1] || null, alternative2: products[2] || null, fallbacks };
  }
  function el(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }
  function imageBox(p) {
    const box = el('div', 'esf-product-image');
    const fallback = el('span', '', "Image indisponible");
    box.append(fallback);
    if (p.image) {
      const img = el('img'); img.alt = p.title; img.width = 400; img.height = 400;
      img.loading = 'lazy'; img.addEventListener('error', () => { img.remove(); fallback.hidden = false; });
      img.src = p.image; fallback.hidden = true; box.append(img);
    }
    return box;
  }
  function priceNode(p) {
    const n = el('p', 'esf-price', formatMoney(p.price));
    if (p.compareAtPrice > p.price) n.append(el('del', '', formatMoney(p.compareAtPrice)));
    return n;
  }
  function initialize(root) {
    if (root.dataset.esfReady) return;
    root.dataset.esfReady = 'true';
    const state = { step: 'scenario', scenario: null, budget: null, loading: false, results: null, error: null };
    let run = 0, started = false;
    const panel = root.querySelector('[data-esf-panel]');
    const scenarioTemplate = root.querySelector('[data-esf-scenario]');
    const budgetTemplate = root.querySelector('[data-esf-budget]');
    const live = root.querySelector('[data-esf-live]');
    const progress = root.querySelector('[data-esf-progress]');
    const restart = root.querySelector('[data-esf-restart]');
    const complianceNote = root.querySelector('.esf-note');
    function action(label, name, secondary = false) {
      const b = el('button', secondary ? 'esf-btn esf-secondary' : 'esf-btn', label);
      b.type = 'button'; b.dataset.esfAction = name; return b;
    }
    function title(text) { const node = el('div', 'esf-title', text); node.tabIndex = -1; return node; }
    function productLink(p, position, className, text, matchType = 'exact') {
      const a = el('a', className, text); a.href = p.url;
      a.addEventListener('click', () => trackFinderEvent('recommendation_clicked', {
        scenario: state.scenario, budget: state.budget, product: p.key, sku: p.sku, position, match_type: matchType
      })); return a;
    }
    function render(focus = true) {
      panel.replaceChildren();
      root.setAttribute('aria-busy', String(state.loading));
      restart.hidden = state.step !== 'result' || (!state.loading && !state.error && !state.results?.best);
      if (complianceNote) complianceNote.hidden = !(state.step === 'result' && !state.loading && !state.error && (state.results?.best || state.results?.fallbacks?.length));
      if (progress) {
        const active = ['scenario', 'budget', 'result'].indexOf(state.step);
        [...progress.children].forEach((item, i) => {
          item.removeAttribute('aria-current');
          item.classList.toggle('active', i === active);
          if (i === active) item.setAttribute('aria-current', 'step');
          item.textContent = `${i < active ? '✓' : i + 1} ${["Usage", 'Budget', "Recommandation"][i]}`;
        });
      }
      if (state.step === 'scenario' || state.step === 'budget') {
        panel.append((state.step === 'scenario' ? scenarioTemplate : budgetTemplate).content.cloneNode(true));
        panel.querySelectorAll('[data-esf-scenario-key]').forEach(button => {
          const key = button.dataset.esfScenarioKey;
          button.setAttribute('aria-pressed', String(key === state.scenario));
          const img = button.querySelector('img');
          const src = safeImage(img.dataset.esfImage || ESF_SCENARIO_IMAGES[key]);
          if (src) { img.addEventListener('error', () => img.hidden = true); img.src = src; }
          else img.hidden = true;
        });
        panel.querySelectorAll('[data-esf-budget-key]').forEach(button => {
          button.textContent = budgetLabel(button.dataset.esfBudgetKey);
          button.setAttribute('aria-pressed', String(button.dataset.esfBudgetKey === state.budget));
        });
        const next = panel.querySelector('[data-esf-action="continue"], [data-esf-action="match"]');
        next.disabled = !(state.step === 'scenario' ? state.scenario : state.budget);
        live.textContent = state.step === 'scenario' ? "Vous cherchez encore la trottinette électrique idéale ?" : "Choisissez votre budget";
      } else if (state.loading) {
        const loading = el('div', 'esf-loading'); loading.append(el('span', 'esf-spinner'), el('span', '', "Nous recherchons un modèle adapté…"));
        panel.append(loading); live.textContent = "Nous recherchons un modèle adapté…";
      } else if (state.error) {
        panel.append(title("Les recommandations ne peuvent pas être chargées pour le moment."));
        panel.append(el('p', 'esf-copy', "Veuillez réessayer."));
        const footer = el('div', 'esf-footer');
        footer.append(action("Réessayer", 'match'), action("Recommencer", 'reset', true));
        panel.append(footer); live.textContent = "Les recommandations ne peuvent pas être chargées. Veuillez réessayer.";
      } else if (!state.results?.best) {
        panel.append(title("Aucun modèle correspondant dans cette tranche de budget"));
        panel.append(el('p', 'esf-copy', "Nous ne trouvons actuellement aucun modèle disponible correspondant à la fois à votre usage et à votre budget. Vous pouvez modifier votre budget ou découvrir les options disponibles les plus proches."));
        const footer = el('div', 'esf-footer esf-empty-actions');
        const startOver = action("Recommencer", 'reset', true); startOver.className = 'esf-action';
        footer.append(action("Modifier le budget", 'budget'), startOver); panel.append(footer);
        const fallbacks = state.results?.fallbacks || [];
        if (fallbacks.length) {
          const group = el('div', 'esf-fallbacks');
          group.append(el('div', 'esf-small-title', "Les options les plus proches pour vous"));
          fallbacks.forEach((p, i) => {
            const card = el('div', 'esf-fallback-card'), info = el('div', 'esf-fallback-info');
            const above = p.budgetRelation === 'above';
            const label = above ? "Légèrement au-dessus de votre budget" : "En dessous de la tranche de budget choisie";
            const difference = p.budgetDistance === 0 ? "À la limite supérieure de la tranche de budget choisie" : `${formatMoney(p.budgetDistance)} ${above ? "au-dessus de" : "en dessous de"} votre tranche de budget`;
            info.append(el('p', 'esf-fallback-label', label), el('div', 'esf-fallback-title', p.title), priceNode(p), el('p', 'esf-fallback-difference', difference), el('p', 'esf-subtitle', ESF_FALLBACK.scenarioRelevance[state.scenario]));
            info.append(productLink(p, `fallback_${i + 1}`, 'esf-btn esf-secondary', "Voir le produit →", 'fallback'));
            card.append(imageBox(p), info); group.append(card);
          });
          panel.append(group);
        }
        live.textContent = fallbacks.length ? "Aucun modèle correspondant dans cette tranche de budget. Les options disponibles les plus proches se situent en dehors de la tranche choisie." : "Aucun modèle correspondant dans cette tranche de budget. Modifiez votre budget.";
      } else {
        const p = state.results.best, copy = ESF_SCENARIO_COPY[state.scenario];
        panel.append(title("Notre recommandation pour vous"));
        const best = el('div', 'esf-best'), info = el('div'); best.append(imageBox(p));
        info.append(el('div', 'esf-product-title', p.title), priceNode(p), el('p', 'esf-subtitle', copy.resultSubtitle));
        const benefits = el('ul', 'esf-benefits');
        [`Dans la tranche de budget choisie (${budgetLabel(state.budget)})`, ...copy.benefits.slice(1)].forEach(t => benefits.append(el('li', '', `✓ ${t}`)));
        info.append(benefits, productLink(p, 'best', 'esf-btn', `Voir ${p.title} →`)); best.append(info); panel.append(best);
        const reason = el('div', 'esf-reason'); reason.append(el('div', 'esf-small-title', "Pourquoi nous recommandons ce modèle"), el('p', '', copy.reason)); panel.append(reason);
        const alternatives = [state.results.alternative1, state.results.alternative2].filter(Boolean);
        if (alternatives.length) {
          const group = el('div', 'esf-alternatives'), grid = el('div', 'esf-alt-grid');
          group.append(el('div', 'esf-small-title', "Autres modèles adaptés"));
          alternatives.forEach((alt, i) => {
            const link = productLink(alt, `alternative_${i + 1}`, 'esf-alt'); const content = el('div');
            content.append(el('strong', '', alt.title), priceNode(alt), el('span', 'esf-alt-label', i === 0 ? "Alternative" : "Autre option"));
            link.append(imageBox(alt), content, el('span', '', '→')); grid.append(link);
          });
          group.append(grid); panel.append(group);
        }
        const footer = el('div', 'esf-footer'); footer.append(action("Modifier le budget", 'budget', true)); panel.append(footer);
        live.textContent = `Notre recommandation pour vous : ${p.title}, ${formatMoney(p.price)}.`;
      }
      if (focus && !state.loading) (panel.querySelector('.esf-title') || root.querySelector('.finder-intro-title'))?.focus({ preventScroll: true });
    }
    async function match() {
      if (state.loading || !state.scenario || !state.budget) return;
      const currentRun = ++run;
      state.step = 'result'; state.loading = true; state.results = null; state.error = null; render(false);
      restart.focus({ preventScroll: true });
      try {
        const results = await getRecommendations(state.scenario, state.budget);
        if (currentRun !== run || !root.isConnected) return;
        state.results = results;
        if (results.best) trackFinderEvent('recommendation_viewed', {
          scenario: state.scenario, budget: state.budget, best_product: results.best.key, best_sku: results.best.sku
        });
        else if (results.fallbacks?.length) trackFinderEvent('recommendation_fallback_viewed', {
          scenario: state.scenario, budget: state.budget, products: results.fallbacks.map(p => p.sku), match_type: 'fallback'
        });
      } catch (_) { if (currentRun === run) state.error = true; }
      if (currentRun === run && root.isConnected) { state.loading = false; render(); }
    }
    root.addEventListener('click', event => {
      const b = event.target.closest('button'); if (!b || !root.contains(b) || b.disabled) return;
      if (b.dataset.esfScenarioKey) {
        if (!started) { started = true; trackFinderEvent('e_scooter_finder_start'); }
        state.scenario = b.dataset.esfScenarioKey;
        panel.querySelectorAll('[data-esf-scenario-key]').forEach(n => n.setAttribute('aria-pressed', String(n === b)));
        panel.querySelector('[data-esf-action="continue"]').disabled = false;
        trackFinderEvent('scenario_selected', { scenario: state.scenario }); return;
      }
      if (b.dataset.esfBudgetKey) {
        state.budget = b.dataset.esfBudgetKey;
        panel.querySelectorAll('[data-esf-budget-key]').forEach(n => n.setAttribute('aria-pressed', String(n === b)));
        panel.querySelector('[data-esf-action="match"]').disabled = false;
        trackFinderEvent('budget_selected', { scenario: state.scenario, budget: state.budget }); return;
      }
      switch (b.dataset.esfAction) {
        case 'continue': if (state.scenario) { state.step = 'budget'; render(); } break;
        case 'back': state.step = 'scenario'; render(); break;
        case 'budget': ++run; state.step = 'budget'; state.loading = false; state.error = null; state.results = null; render(); break;
        case 'match': match(); break;
        case 'reset':
          ++run; Object.assign(state, { step: 'scenario', scenario: null, budget: null, loading: false, results: null, error: null });
          started = false; trackFinderEvent('finder_reset'); render(); break;
      }
    });
    root.hidden = false; render(false);
  }
  function initializeAll(scope = document) {
    scope.querySelectorAll('[data-escooter-finder]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(), { once:true });
  else initializeAll();
  document.addEventListener('shopify:section:load', e => initializeAll(e.target));
})();
